import { z } from "zod";

export type AppErrorType = "404" | "session-expired";

export const appErrorPaths: Record<AppErrorType, string> = {
  "404": "/errors/404",
  "session-expired": "/errors/session-expired",
};

export const appErrorSearchSchema = z.object({
  from: z.string().optional(),
});

export function isAppErrorPath(pathname: string) {
  return Object.values(appErrorPaths).some((path) => path === pathname);
}

export function buildAppErrorUrl(type: AppErrorType, from?: string) {
  const path = appErrorPaths[type];

  if (!from) {
    return path;
  }

  const searchParams = new URLSearchParams({ from });
  return `${path}?${searchParams.toString()}`;
}
